/**
 * Calculates optimal column width based on data content
 * @param {Array} dataItems - Array of data objects
 * @param {string} field - Field name to analyze
 * @param {string} title - Column header title
 * @returns {number} Calculated width in pixels
 */
export function calculateColumnWidth(dataItems, field, title) {
  if (!dataItems || dataItems.length === 0) return 150; // Default width if no data

  // Calculate max content length in the data
  const maxContentLength = dataItems.reduce((max, item) => {
    const value = item[field];
    const length = value ? String(value).length : 0;
    return Math.max(max, length);
  }, 0);

  // Also consider the header title length
  const headerLength = title ? title.length : 0;
  const maxLength = Math.max(maxContentLength, headerLength);

  // Calculate width: ~8px per character + 40px padding for cell spacing
  const calculatedWidth = maxLength * 8 + 40;

  // Apply min/max constraints
  const minWidth = 100;
  const maxWidth = 300;

  return Math.min(Math.max(calculatedWidth, minWidth), maxWidth);
}

/**
 * Calculates widths for all columns based on current data
 * @param {Array} dataItems - Array of data objects
 * @param {Array} columns - Array of column configurations
 * @returns {Object} Map of field names to calculated widths
 */
export function calculateColumnWidths(dataItems, columns) {
  if (!dataItems || !columns) return {};

  return columns.reduce((widths, column) => {
    // Only calculate width for columns without a fixed width
    if (!column.width && column.field) {
      widths[column.field] = calculateColumnWidth(dataItems, column.field, column.title);
    }
    return widths;
  }, {});
}
